import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { HotToastService } from '@ngneat/hot-toast';


@Injectable({
  providedIn: 'root'
})
export class MessageService {

  duration = 3000;

  constructor(
    private toast: HotToastService,
    private translate: TranslateService) { }

  showErrorMessage(errorMessage: string) {
    this.translate.get(errorMessage).subscribe((res: string) => {
      this.toast.error(res);

    });

  }

  showMessage(message: string, value = null) {
    this.translate.get(message, { valor: value }).subscribe(res => {
      this.toast.success(res);
    });
  }

  parseMessage(message: string, longMessage = false): string {

    let messageOut: string;

    if (message && message.startsWith('@')) {
      const toParse = message.split('#')[1];
      const valuesArray = toParse.split('_');

      const n_stock = valuesArray[0];
      const n_needed = valuesArray[1];
      const carats = valuesArray[2];
      const gemType = valuesArray[3];

      if (longMessage) {

        messageOut = `There are ${n_stock} of ${n_needed} ${gemType} with${carats} required`;
      } else {
        messageOut = `${n_needed} ${gemType} ${carats} Required`;
      }

    } else {

      messageOut = `ERRORS.BREAKDOWN.${message}`;
    }

    return messageOut;
  }


  showError(errorMessage: string) {
    this.toast.error(errorMessage);
  }

}
